import { useMemo } from 'react'

import { useAvatarSkins } from '@store'

export const useAvatars = () => {
  const avatars = useAvatarSkins()

  const sortedAvatars = useMemo(() => {
    return avatars.sort((a) => (a.isAvailable ? -1 : 1))
  }, [avatars])

  return { avatars: sortedAvatars }
}
